//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import _ from 'underscore'

export default {
  components: {
  },
  props: {
    tableData: {
      default: () => []
    },
    initialForm: {
      default: () => ({})
    },
    loading: {
      default: false
    }
  },
  data: function () {
    return {
      currentTableData: this.tableData,
      rowData: {
        default: () => ({})
      },
      addDialogVisible: false,
      editDialogVisible: false,
      detailDialogVisible: false
    }
  },
  watch: {
    tableData: {
      handler (val) {
        this.currentTableData = val
      },
      immediate: true
    }
  },
  methods: {
    unDate(){
      console.log('加载')
    },
    handleBatch(row) {
      if (row.state.submiting === false) {
        let data = _.pick(this.initialForm, 'dealerId')
        let url = '/mtea/store/admin/dealer/relation/batch'
        let items = []
        items.push({gid: row.data.goodsId, cost_price: row.data.price})
        if (row.data.price <= 0) {
          this.$message.error('价格应该大于0')
          return
        }
        data.items = JSON.stringify(items)
        row.state.submiting = true
        this.$axios.post(url, data).then(res => {
          this.$notify.success({
            title: '系统提示',
            message: '操作成功'
          })
          row.data.selected = 1
          row.state.showPopover = false
          this.$emit('submit')
        }, () => {
        }).finally(() => {
          row.state.submiting = false
        })
      }
    },
    handleUpdatePrice (row) {
      if (row.state.submiting === false) {
        let data = _.extend({gid: row.data.goodsId, did: this.initialForm.dealerId, costPrice: row.data.costPrice})
        console.log('data', data)
        row.state.submiting = true
        this.$axios.post('/mtea/store/admin/dealer/relation/update', data).then(res => {
          this.$notify.success({
            title: '系统提示',
            message: '操作成功'
          })
          row.state.showPopover1 = false
        }).finally(() => {
          row.state.submiting = false
        })
      }
    },
    handleDel(row){
      if(row.state.submiting === false){
        let url = '/mtea/store/admin/dealer/relation/del'
        let data = _.pick(this.initialForm, 'dealerId')
        row.state.submiting = true
        data.gids = row.data.goodsId
        this.$axios.post(url, data).then(res => {
          this.$notify.success({
            title: '系统提示',
            message: '操作成功'
          })
          row.data.selected = 0
          this.$emit('submit')
        }, () => {
        }).finally(() => {
          row.state.submiting = false
        })
      }
    },
    handleBatchOrDel(row) {
      let data = _.pick(this.initialForm, 'dealerId')
      let url = '/mtea/store/admin/dealer/relation/batch'
      if (row.data.selected === 1) {
        url = '/mtea/store/admin/dealer/relation/del'
        data.gids = row.data.goodsId
      } else {
        let items = []
        items.push({gid: row.data.goodsId, cost_price: row.data.price})
        if (row.data.price <= 0) {
          this.$message.error('价格应该大于0')
          row.data.selected = [1, 0][row.data.selected]
          return
        }
        data.items = JSON.stringify(items)
      }
      row.state.submiting = true
      this.$axios.post(url, data).then(res => {
        this.$notify.success({
          title: '系统提示',
          message: '操作成功'
        })
        this.$emit('submit')
      }, () => {
        row.data.selected = [1, 0][row.data.selected]
      }).finally(() => {
        row.state.submiting = false
      })
    }
  }
}
